import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Injector,
  OnInit } from '@angular/core';
import { Store } from '@softline/core';
import { Observable } from 'rxjs';
import { Modal} from '@softline/ui-core';
import { CommonModule } from '@angular/common';
import { Objekt } from '../../data/objekt';
import {
  ObjectQueryRecentObjectsStore,
  SOFTLINE_FEATURE_OBJECT_QUERY_RECENT_OBJECTS } from '../../objektabfrage.shared';
import { handleRequestError } from '@softline/application';

const RECENT_OBJECT_COUNT = 8;

import { LoadingSpinnerComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-objektabfrage-recent-objects-dialog',
  templateUrl: './recent-objects-dialog.component.html',
  styleUrls: ['./recent-objects-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule,
    LoadingSpinnerComponent,
    TranslatePipe] })
export class RecentObjectsDialogComponent
  implements OnInit, Modal<Objekt | undefined>
{
  private injector = inject(Injector);

  close!: (result?: Objekt) => void;

  recentObjects$: Observable<readonly Objekt[]> = this.store.observe(
    SOFTLINE_FEATURE_OBJECT_QUERY_RECENT_OBJECTS,
    ObjectQueryRecentObjectsStore.getters.all
  );

  loading$: Observable<boolean> = this.store.observe(
    SOFTLINE_FEATURE_OBJECT_QUERY_RECENT_OBJECTS,
    ObjectQueryRecentObjectsStore.getters.loading
  );

  constructor(private store: Store) {}

  async ngOnInit(): Promise<void> {
    const queryParams = { letzenArbeitsberichte: RECENT_OBJECT_COUNT };
    try {
      await this.store.dispatch(
        SOFTLINE_FEATURE_OBJECT_QUERY_RECENT_OBJECTS,
        ObjectQueryRecentObjectsStore.actions.loadMany,
        { clear: true, queryParams }
      );
    } catch (e) {
      handleRequestError(e, this.injector, { show: true });
    }
  }

  registerCloseHandler(handler: (result?: Objekt) => void) {
    this.close = handler;
  }
}
